/** Logical identities remain unchanged; only the editor's physical URI is rooted. */
export function rootedModelIdentity(identity: string, owner: string): string {
  const fragment = identity.indexOf("#");
  const base = fragment < 0 ? identity : identity.slice(0, fragment);
  const suffix = fragment < 0 ? "" : identity.slice(fragment);
  return `${base}${base.includes("?") ? "&" : "?"}workerstation-root=${encodeURIComponent(owner)}${suffix}`;
}
